<template>
  <div class="py-4 space-y-4">
    <div class="space-y-2 animate-pulse">
      <div class="h-6 bg-n-slate-5 dark:bg-n-alpha-black1 rounded w-2/5" />
    </div>
    <div class="space-y-2 animate-pulse">
      <div class="h-4 bg-n-slate-5 dark:bg-n-alpha-black1 rounded" />
      <div class="h-4 bg-n-slate-5 dark:bg-n-alpha-black1 rounded" />
      <div class="h-4 bg-n-slate-5 dark:bg-n-alpha-black1 rounded" />
    </div>
    <div class="space-y-2 animate-pulse">
      <div class="h-4 bg-n-slate-5 dark:bg-n-alpha-black1 rounded w-1/5" />
    </div>
  </div>
</template>
